const pluralizationTypes = {
    SINGLE: 1,
    PLURAL: 2,
}
export default pluralizationTypes;